import React, {useState} from 'react'
import { StyleSheet, View } from 'react-native'

import {
  Title,
  Button,
  Description,
  Space,
  ErrorMessage
} from '@sart/components'
import {
  GuruRelaxed,
  GuruVictoryDance 
} from '@sart/icons'
import { useContent } from '@sart/content'
import client, { useClient } from '@sart/client'

import { colors, typography } from '@sart/styles'

export default function ConfirmCancel(props) {
  const { navigation, route } = props
  const {
    cache: {
      basket
    } = {}
  } = useClient()
  const content = useContent()
  const [submitting, setSubmitting] = useState(false)
  // const title = navigation.getParam('title')
  // const description = navigation.getParam('description')
  // const addOn = navigation.getParam('addOn')
  // const instanceId = navigation.getParam('instanceId')
  const addOn = route.params?.addOn
  const instanceId = route.params?.instanceId
  const title = addOn.product.productName
  const description = content.dashboard.cancelDescription

  async function cancelRecurringAddOn(addOn, instanceId) {
    setSubmitting(true)
    const order = await client.checkoutServiceDelProduct(addOn, { instanceId })
    if(order.status && order.status === "successful") {
      const confirmation = {
        title: content.common.cancelled,
        description: `${title} ${content.dashboard.cancelSuccessful}`
      }
      navigation.navigate('Confirmation', confirmation)
    } else {
      const confirmation = {
        title: content.common.cancelled,
        description: `${title} ${content.dashboard.cancelFailed}`
      }
      navigation.navigate('Confirmation', confirmation)
    }
  }

  return (
    <View style={styles.container}>

      <GuruRelaxed width={220} height={181}/>

      <Space height={48} />

      <Title style={styles.title}>{title}</Title>

      <Space height={24} />

      <Description style={styles.description}>{description}</Description>

      <Space height={48} />

      <Button
        style={styles.button}
        title={submitting ? content.common.submitting : content.common.confirm}
        onPress={() => {cancelRecurringAddOn(addOn.product, instanceId)}}
        disabled={submitting}
        titleStyle={{...typography.extrabold, fontSize: 18}}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.srGreen,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24
  },
  title: {
    color: colors.clear,
    ...typography.bold
  },
  description: {
    textAlign: 'center',
    color: colors.black,
    ...typography.lightbold
  },
  button: {
    alignSelf: 'stretch',
    backgroundColor: colors.srGreyBackground
  },
})
